<template>
  <VCombobox
    :label="label"
    :value="value"
    :required="required"
    :disabled="disabled"
    :hide-details="!info"
    :hint="info"
    multiple
    chips
    :rules="required ? isRequired : []"
    deletable-chips
    @change="$emit('change', {val: $event, name: name})"
  />
</template>
<script>
  import defaultProps from './props.js'
  export default {
    props: [...defaultProps.default],
    data () {
      return {
        isRequired: [
          (value) => {
            if (value?.length > 0) return true
            return `${this.label || this.name} ist erforderlich.`
          },
        ],
      }
    },
  }
</script>
